import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure: false
})
export class OrderByPipe implements PipeTransform {
  transform(value: any[], property: string, descending?: boolean): any {
    const propertyArray = property.split('.');

    if (!value) {
      return value;
    }

    value.sort(
      (first: any, second: any): number => {
        let tempFirst = first;
        let tempSecond = second;
        for (const item of propertyArray) {
          if (tempFirst[item] && tempSecond[item]) {
            tempFirst = tempFirst[item];
            tempSecond = tempSecond[item];
          }
        }
        return tempFirst >= tempSecond ? 1 : -1;
      }
    );

    if (descending) {
      return value.reverse();
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/orderBy/orderByPipe.ts